// extracted by mini-css-extract-plugin
module.exports = {"background":"AboutUs_background__3w_6L","bapic":"AboutUs_bapic__1BNGq"};